import { ApplicationRoutes } from '../../../app-routes-names'

export const SamplesRoutes = {
  sankeyChart: 'sankey-chart',
  map: 'map',
  shopMap: 'location-map',
  mapClustering: 'map-clustering',
  mapMarkers: 'map-markers',
  doughnutChart: 'doughnut-chart'
}

const { samples } = ApplicationRoutes

export const SamplesPaths = {
  sankeyChart: `/${samples}/${SamplesRoutes.sankeyChart}`,
  map: `/${samples}/${SamplesRoutes.map}`,
  shopMap: `/${samples}/${SamplesRoutes.shopMap}`,
  mapClustering: `/${samples}/${SamplesRoutes.mapClustering}`,
  mapMarkers: `/${samples}/${SamplesRoutes.mapMarkers}`,
  doughnutChart: `/${samples}/${SamplesRoutes.doughnutChart}`
}
